import React, {Component} from 'react'

class HelpCA002 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />ユーザを登録・編集・削除する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[CA2-1]</span>画面上部のメニューの中の「日常業務」の「ユーザ管理」(図CA2-1 参照)を押してください。</legend>
              <figcaption>図CA2-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_CA2-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[CA2-2-1]</span>新規でユーザを作成する場合は右上の「新規」ボタン(図CA2-2-1 参照)を押してください。</legend>
              <figcaption>図CA2-2-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_CA2-2-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[CA2-2-2]</span>編集、削除、一時無効を行う場合は詳細画面上部のそれぞれのボタン(図CA2-2-2 参照)を押してください。</legend>
              <figcaption>図CA2-2-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_CA2-2-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default HelpCA002



// WEBPACK FOOTER //
// ./src/help/HelpCA002.js